import { render, staticRenderFns } from "./ShowStep.vue?vue&type=template&id=688800c4&scoped=true"
import script from "./ShowStep.vue?vue&type=script&lang=ts"
export * from "./ShowStep.vue?vue&type=script&lang=ts"
import style0 from "./ShowStep.vue?vue&type=style&index=0&id=688800c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688800c4",
  null
  
)

export default component.exports